const CDN_BASE = "https://cdn.hkmchennai.org/cdn-files";
export const Banner = `${CDN_BASE}/mandir_nirman_seva_banner.png`;
export const avatar = `${CDN_BASE}/Avatar-PNG-Image.webp`;
export const ddd_poster_mob = `${CDN_BASE}/ddd_poster_mob.jpg`;
export const ddd_poster_dektop = `${CDN_BASE}/ddd_poster_desktop.jpg`;
export const temple_main1 = `${CDN_BASE}/Front_View_from_AP.jpg`;
export const temple_main2 = `${CDN_BASE}/Top_Valley_View.jpg`;
export const temple_main3 = `${CDN_BASE}/Top_View.jpg`;
export const img_annadanam = `${CDN_BASE}/annadanam_hall.jpg`;
export const img_festival = `${CDN_BASE}/festival_hall.jpg`;
export const img_kalamadhuryam = `${CDN_BASE}/kala_madhuryam.jpg`;
export const img_harinam = `${CDN_BASE}/harinaam_mandap.jpg`;
export const img_icvk = `${CDN_BASE}/icvk.jpg`;
export const img_gitalife = `${CDN_BASE}/gita_life.jpg`;
export const altar = `${CDN_BASE}/majestic_altar.jpg`;
export const culturalHallBg = `${CDN_BASE}/cultural_hall_bg.jpg`;
export const transparentLogo = `${CDN_BASE}/transparent_logo.png`;
export const bannerBg = `${CDN_BASE}/campaigner_page_banner_desktop.jpeg`;
export const mobileHeroBg = `${CDN_BASE}/campaigner_page_banner_mobile.png`;
export const donorBg = `${CDN_BASE}/donation_page_bg.jpg`;
export const templeLogo = `${CDN_BASE}/logo.png`;
export const giftImg = `${CDN_BASE}/gift.jpg`;
export const taxImg = `${CDN_BASE}/tax.jpg`;
export const education_wing = `${CDN_BASE}/education_wing.jpg`;
export const logo = `${CDN_BASE}/logo.png`;
export const prabhupadaImg = `${CDN_BASE}/prabhupada.jpg`;
export const booksImg = `${CDN_BASE}/vedic_books.jpg`;
export const pujaImg = `${CDN_BASE}/puja.jpg`;
export const render1 = `${CDN_BASE}/ddd_arc_1.jpg`;
export const render2 = `${CDN_BASE}/ddd_arc_4.jpg`;
export const render3 = `${CDN_BASE}/ddd_arc_2.jpg`;
export const render4 = `${CDN_BASE}/ddd_arc_3.jpg`;
export const altarImg = `${CDN_BASE}/altar.jpg`;
export const highlightBg = `${CDN_BASE}/high_light_bg.png`;
export const t1 = `${CDN_BASE}/t1.jpeg`;
export const t2 = `${CDN_BASE}/t2.jpg`;
export const t3 = `${CDN_BASE}/t3.jpg`;
export const t4 = `${CDN_BASE}/t4.jpg`;
export const vishnu_purana = `${CDN_BASE}/vishnu_purana.mp4`;
export const vamana_purana = `${CDN_BASE}/vamana_purana.mp4`;
export const garuda_purana = `${CDN_BASE}/garuda_purana.mp4`;
export const lotusBud = `${CDN_BASE}/lotus_bud.jpg`;
export const lotusBloom = `${CDN_BASE}/lotus_blossom.jpg`;
export const weekly_lotusBud = `${CDN_BASE}/lotus_bud_small.png`;
export const weekly_lotusBloom = `${CDN_BASE}/lotus_bloom_small.png`;